(function () {
  angular.module("akitabox.core.services.job.job", [
    "akitabox.constants",
    "akitabox.core",
    "akitabox.core.services.http",
    "akitabox.core.services.pinType",
    "akitabox.core.services.organization",
  ]);
})();
